import { render, staticRenderFns } from "./order-kit-detail.vue?vue&type=template&id=da0afc74&scoped=true&"
import script from "./order-kit-detail.vue?vue&type=script&lang=js&"
export * from "./order-kit-detail.vue?vue&type=script&lang=js&"
import style0 from "./order-kit-detail.vue?vue&type=style&index=0&id=da0afc74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0afc74",
  null
  
)

export default component.exports